import React, { useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import AxiosRequest from 'src/axiosRequests'
import { useNavigate } from 'react-router-dom'

const Login = () => {
  const [user, setUser] = useState({
    email: '',
    password: '',
  })

  const handleChange = (event) => {
    setUser((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }))
  }

  const navigate = useNavigate()

  const handleSubmit = (event) => {
    event?.preventDefault()
    const headers = {
      'Content-Type': 'application/json',
    }
    const data = {
      email: user.email,
      password: user.password,
    }
    AxiosRequest.post('/auth/login', data, {
      headers: headers,
    })
      .then((response) => {
        if (response.status) {
          sessionStorage.setItem('token', response.data.token)
          sessionStorage.setItem('userInfo', JSON.stringify(response.data.user))

          navigate('/dashboard')
        }
      })
      .catch((error) => {
        if (error.response && error.response.status >= 400 && error.response.status <= 500) {
          alert(error.message)
        }
      })
  }

  const handleLogin = (e) => {
    if (e.keyCode == 13) {
      handleSubmit()
    }
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm>
                    <h1>Login</h1>
                    <p className="text-medium-emphasis">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Email"
                        autoComplete="email"
                        name="email"
                        type="email"
                        onChange={handleChange}
                        onKeyUp={handleLogin}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        name="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        onChange={handleChange}
                        onKeyUp={handleLogin}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol md={4}>
                        <CButton color="primary" className="px-4" onClick={handleSubmit}>
                          Login
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
